import { Link } from 'react-router-dom'
import { Breadcrumb , Collapse,message } from 'antd';
import './FAQ.less'
import copy from "copy-to-clipboard";
import { useEffect, useState } from 'react';
import { post } from 'request/request';
import Item from 'antd/es/list/Item';
import { useSelector } from 'react-redux';
import { selectLocale } from 'store/localeSlice';
import { useIntl } from 'react-intl';

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}


const { Panel } = Collapse;


export default () => {
	const [faqList, setFaqList] = useState([])
	const locale= useSelector(selectLocale);
	const intl = useIntl();
	
	useEffect(() => {
        post('snailcar/website/common/queryFaq',{pageNo: 1,pageSize: 999}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setFaqList(data.resultBody.data.list)
            }
        })
    }, [])
	return<div className="FAQ">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">{intl.formatMessage({id: 'header.menus.home'})}</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>{intl.formatMessage({id: 'footer.menus.INFO.FAQ'})}</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">FAQ</div>
				<Collapse ghost defaultActiveKey={['0']}>
					{faqList.map((item:any, index) => <Panel header={item.name} key={index}>
						<p style={{paddingLeft: '30px',whiteSpace: 'pre-line'}}>{item.des}</p>
					</Panel>)}
					
					{/* 
					<Panel header="Do your products need assembly?" key="1">
						<p style={{paddingLeft: '30px'}}>Assembly is required on most of our equipment. These items come packed tightly and securely from the factory and do require assembly. This is the best way for the customer to receive their item in a manner that is less likely to get damaged during shipping.</p>
					</Panel>
					<Panel header="How do I get assembly assistance?" key="2">
						<p style={{paddingLeft: '30px'}}>All our products come with assembly instructions within the User Manual booklet. If further assistance is needed, you can send emails to <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span></p>
					</Panel>
					<Panel header="My item arrived and it is damaged. What do I do?" key="3">
						<p style={{paddingLeft: '30px'}}>Firstly, take a deep breath. It's hard for major shipping carriers to deliver heavy packages perfectly every single time. We suggest to open the box and take a look inside. The items come packaged fairly well on the inside, so just because the outside box is dinged up, doesn't mean what's inside is dinged as well.</p>
						<p style={{paddingLeft: '30px'}}>If you do encounter an issue, contact us immediately. Don't start disassembling the item and packing things back up in the box just yet. Reach out to us first and see if there's an easier solution. We carry many of replacement parts and knowledgeable staff to help troubleshoot any situation. You can reach out to us through <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span></p>
					</Panel>
					<Panel header="Where can I find Users’ manual for the product?" key="4">
						<p style={{paddingLeft: '30px'}}>The Users manual is shipped with your products. Please read manual first before assembling the products. All our products have available PDF User Manuals. If you need a soft copy of the Manual, please each out to us through <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span></p>
					</Panel>
					<Panel header="Do you sell replacement parts for products that are out of warranty?" key="5">
						<p style={{paddingLeft: '30px'}}>Most of our products we carry offer the entire line of replacement parts for purchase if you find the need to fix your item that is out of warranty. Please refer to your user manual to find the correct part # and email us for stock availability and pricing. You can reach out to us through <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span></p>
					</Panel>
					<Panel header="Do you offer free returns?" key="6">
						<p style={{paddingLeft: '30px'}}>Unfortunately, No we do not. However, if your item you just received has issues, arrived damaged or isn't working (malfunctioning), of course you won't have to pay to return it. We will provide you with return shipping at no cost to you. But if you would like to return the item that is in 100% working good condition, we will still gladly take the return back. However, the return shipping costs/services will not be provided by us. For more info on our return policy, click here:(转到 return and refund policies)</p>
					</Panel> */}
				</Collapse>
			</div>
		</div>
	</div>
}